import { LegalClientSaveConstitutionalDocumentParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

import { CompanyConstituentDocsFormType } from '../../forms/companyConstituentDocs';

export const getSubmitData = (
  values: CompanyConstituentDocsFormType
): LegalClientSaveConstitutionalDocumentParam => ({
  dateOfLastChange: values.dateOfLastChange
    ? formatToISODate(values.dateOfLastChange)
    : undefined,
  fileIds: values.fileIds,
});
